import styled from '@emotion/styled';
import { useSendingLeadConversionAPI } from 'hooks/api';
import { useEffect, useState } from 'react';
import ReactPixel from 'react-facebook-pixel';
import Cookies from 'js-cookie';

const Eigth:React.FC<any> = () => {
  const handleAppStore = async () => {
    const fbc = Cookies.get('_fbc') || "";
    window.open("https://apps.apple.com/kr/app/%ED%8F%AC%ED%8B%B0%ED%8E%98%ED%83%80-%ED%94%84%EB%A6%AC%EB%AF%B8%EC%97%84-%EC%9D%B8%ED%99%94%EA%B5%AC%EB%8F%85/id1619040733", "_blank")
    ReactPixel.fbq('trackCustom', 'App_Up_AppInstall', {
      "content_name": 'App Install',
      "content_category": 'Mobile App',
      "fbc": fbc,
      "store": 'appStore',
      "city": "KR",
      "gender" : "female"
    })
    
    // await postLeadConversionAPI({ fbclid, source, medium, content, fbc })
  }

  const handleGoogle = async () => {
    const fbc = Cookies.get('_fbc') || "";
    window.open("https://play.google.com/store/apps/details?id=com.photypeta.photypetaApp", "_blank");
    ReactPixel.fbq('trackCustom', 'App_Up_AppInstall', {
      "content_name": 'App Install',
      "content_category": 'Mobile App',
      "fbc": fbc,
      "store": 'googlePlayStore',
      "city": "KR",
      "gender" : "female"
    })
  }

  return (
    <Container>
      <ImgContainer className="logo">
        <Img src="/images/klikkie/main/logo.png"/>
      </ImgContainer>
      <TextContainer>
      <BoldText>
        사진 정리 
        <br/>이제 구독으로 부담없이
      </BoldText>
      <SmallText>
        포티페타 앱에서 <br/>간편하게 시작하세요.
      </SmallText>
      </TextContainer>
      <StoreContainer>
        <ImgContainer className="store"
          onClick={handleAppStore}
        >
          <Img src="/images/klikkie/main/AppStore3.png"/>
        </ImgContainer>
        <ImgContainer className="store"
          onClick={handleGoogle}
        >
          <Img src="/images/klikkie/main/GooglePlay3.png"/>
        </ImgContainer>
      </StoreContainer>
      <ImgContainer className='full'>
        <Img src="/images/klikkie/main/readingABook2.png"/>
      </ImgContainer>
    </Container>
  )
};

export default Eigth;

const Container = styled.div`
  width: 100%;
  min-height: 619px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImgContainer = styled.div`
  &.logo {
    margin-top: 112px;
    width: 80px;
    margin-bottom: 41px;
  }

  &.store{
    width: 100%;
  }

  &.full {
    width: 100%;
  }
`;

const Img = styled.img`
  width: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
  text-align: center;
`

const BoldText = styled.div`
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  line-height: 1.5;
  
`;

const SmallText = styled.div`
font-size: 20px;
  margin-top: 29px;
`;

const StoreContainer = styled.div`
  width: 145px;
  min-height: 95px;
  /* background-color: aqua; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 70px;
  margin-bottom: 85px;
`;
